import React from 'react';
import './PerformanceBanner.css';

function PerformanceBanner({ performance }) {
  if (!performance) return null;

  const {
    queryTime,
    loadTime,
    filterTime,
    rowCount
  } = performance;

  return (
    <div className="performance-banner db-mode">
      <div className="performance-item">
        <span className="performance-label">Query Time:</span>
        <span className="performance-value">{queryTime}ms</span>
      </div>
      {loadTime !== undefined && (
        <div className="performance-item">
          <span className="performance-label">Load Time:</span>
          <span className="performance-value">{loadTime}ms</span>
        </div>
      )}
      {filterTime !== undefined && (
        <div className="performance-item">
          <span className="performance-label">Filter Time:</span>
          <span className="performance-value">{filterTime}ms</span>
        </div>
      )}
      <div className="performance-item">
        <span className="performance-label">Rows Processed:</span>
        <span className="performance-value">{rowCount?.toLocaleString()}</span>
      </div>
    </div>
  );
}

export default PerformanceBanner;
